import { ReactElement } from 'react'
import { Chip } from '@mui/material'
import { Box } from '@ui/structure'

/**
 * The project's tags as chips. They are the user's own labels, so the cell
 * shows as many as fit and keeps the full list in the title attribute rather
 * than growing the row.
 */
const TagsCell = ({ tags }: { tags: string[] }): ReactElement | null => {
  if (!tags.length) return null

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={0.5}
      height="100%"
      sx={{ overflow: 'hidden' }}
      title={tags.join(', ')}
      data-cy="project-tags-cell"
    >
      {tags.map(tag => (
        <Chip key={tag} label={tag} size="small" />
      ))}
    </Box>
  )
}

export default TagsCell
